import { render, staticRenderFns } from "./NewProductEnd.vue?vue&type=template&id=13b2575d&"
import script from "./NewProductEnd.vue?vue&type=script&lang=js&"
export * from "./NewProductEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports